// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3tX2u","inputWrap":"styles_inputWrap__3FKKG","input":"styles_input__2FMQq"};